/* eslint no-use-before-define : 'off' */
import { createStore, applyMiddleware } from "redux";
import rootReducer from "../reducers/rootReducer";
import thunk from 'redux-thunk';
import { composeWithDevTools } from "redux-devtools-extension";


  function saveToLocalStorage(state) {
    try {
      const serializedState = JSON.stringify(state)
      localStorage.setItem('state', serializedState)
    } catch(e) {
      console.log(e)
    }
  }
  
  // function loadFromLocalStorage() {f
  //   try {
  //     const serializedState = localStorage.getItem('state')
  //     if (serializedState === null) return undefined
  //     return JSON.parse(serializedState)
  //   } catch(e) {
  //     console.log(e)
  //     return undefined
  //   }
  // }


const configureStore = createStore(
    rootReducer,
    persistedState,
    composeWithDevTools(  applyMiddleware(thunk))
);
 
configureStore.subscribe(() => saveToLocalStorage(configureStore.getState().authService))
const persistedState = loadFromLocalStorage();  
 
  function loadFromLocalStorage() {
    try {
      var CompleteObject = configureStore.getState();
      const serializedState = localStorage.getItem('state')
       Object.assign({},CompleteObject.authService);
      CompleteObject.authService = JSON.parse(serializedState);
      
       if (CompleteObject === null) return undefined
       return CompleteObject
      // return JSON.parse(CompleteObject)
    } catch(e) {
      console.log(e)
      return undefined
    }
  }

  
  
  export default configureStore

